import { loadStripe, type Stripe } from '@stripe/stripe-js'

/**
 * True when checkout should use the Mirage mock flow (no real Stripe.js).
 * Mirage intercepts /me/payment-sessions in mockapi mode, so real Stripe can
 * never run there; every other mode talks to the real backend.
 */
export function isMockStripeCheckout(): boolean {
  return import.meta.env.MODE === 'mockapi'
}

let stripePromise: Promise<Stripe | null> | null = null

/**
 * Lazily loads Stripe.js on first use (checkout open) so Stripe's script and
 * tracking stay off every other page.
 */
export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '')
  }
  return stripePromise
}
